export default __webpack_public_path__ + "static/media/0x6ae7dfc73e0dde2aa99ac063dcf7e8a63265108c.036bb2b4.webp";